import { MyOrganismVideoDefault, OrganismVideoProps, VideoData } from 'wolf/components/organisms/o-video/o-video.data';
import { Component } from '../../../../global/interfaces/component.interface';
import { MyMoleculeVideoOverlayLayoutDefault } from '../m-video-overlay/m-video-overlay.data';
import { v4 as uuidv4 } from 'uuid';
import MyAtomEnergyBadge, { AtomEnergyBadgeProps } from 'wolf/components/atoms/a-energy-badge/a-energy-badge.data';

// type ProductGalleryItemTypes = 'image' | 'video' | '360';
export enum ProductGalleryItemTypes {
	Image = 'image',
	Video = 'video',
	ThreeSixty = '360',
}


export interface MoleculeProductGalleryProps {
	/** List of images, videos and 360 images */
	mediaItems: Array<IImageItem | IVideoItem | IThreeSixtyItem>;
	/** The energy badge shown over the image and 360 slides (not video) */
	energyBadge: AtomEnergyBadgeProps;
	/** The zero-indexed item which will be selected on load */
	currentlySelected?: number;
	fullscreen?: boolean;
}
const fake360: IThreeSixtyItem = {
	type: ProductGalleryItemTypes.ThreeSixty,
	thumb: 'https://scaleflex.ultrafast.io/https://scaleflex.airstore.io/demo/chair-360-36/chair_1.jpg?v1',
	folder: 'https://scaleflex.ultrafast.io/https://scaleflex.airstore.io/demo/chair-360-36/',
	filenamePattern: 'chair_{index}.jpg?v1',
	amountOfImages: 36,
	magnifierZoom: 3,

};
const fake360_2: IThreeSixtyItem = {
	type: ProductGalleryItemTypes.ThreeSixty,
	thumb: 'https://test.main-demo.de.wolf.eu/demo-product-images-360/images/03_960x480/cha-1.png',
	folder: 'https://test.main-demo.de.wolf.eu/demo-product-images-360/images/03_960x480/',
	filenamePattern: 'cha-{index}.png',
	amountOfImages: 36,
	magnifierZoom: 3,
	spinReverse: true,
	speed: 75,
	autoplay: true,
	keyboard: true,
};
// <div
// 	class="cloudimage-360"
// 	data-folder="https://test.main-demo.de.wolf.eu/demo-product-images-360/images/03_960x480/"
// 	data-filename="cha-{index}.png"
// 	data-amount="36"
// 	data-bottom-circle
// 	data-bottom-circle-offset="5"
// 	data-keys
// 	data-autoplay
// 	data-speed="75"
// 	data-magnifier="3"
// 	data-spin-reverse
// ></div>

const fakeImage1: IImageItem = {
	type: ProductGalleryItemTypes.Image,
	// selected: true,
	thumb: 'https://picsum.photos/id/1000/280/244',
	large: 'https://picsum.photos/id/1000/1024/768',
	full: 'https://picsum.photos/id/1000/2400/1800',
};
const fakeImage2: IImageItem = {
	type: ProductGalleryItemTypes.Image,
	thumb: 'https://picsum.photos/id/1047/280/269',
	large: 'https://picsum.photos/id/1047/1047/801',
	full: 'https://picsum.photos/id/1047/2400/1800',
};
const fakeImage3: IImageItem = {
	type: ProductGalleryItemTypes.Image,
	// selected: true,
	thumb: 'https://picsum.photos/id/1042/280/251',
	large: 'https://picsum.photos/id/1042/1024/768',
	full: 'https://picsum.photos/id/1042/2400/1800',
};
const fakeImage4: IImageItem = {
	type: ProductGalleryItemTypes.Image,
	// selected: true,
	thumb: 'https://picsum.photos/id/1043/292/259',
	large: 'https://picsum.photos/id/1043/1024/768',
	full: 'https://picsum.photos/id/1043/2400/1800',
};
const fakeImage5: IImageItem = {
	type: ProductGalleryItemTypes.Image,
	// selected: true,
	thumb: 'https://picsum.photos/id/1044/281/251',
	large: 'https://picsum.photos/id/1044/1024/768',
	full: 'https://picsum.photos/id/1044/2400/1800',
};

const poster = {
	sources: [
		{
			mediaQuery: '(max-width: 1920px)',
			image: 'https://picsum.photos/1920/1024',
			width: 1920,
			height: 1024
		},
		{
			mediaQuery: '(max-width: 1200px)',
			image: 'https://picsum.photos/1200/600',
			width: 1200,
			height: 600
		},
		{
			mediaQuery: '(max-width: 768px)',
			image: 'https://picsum.photos/768/480',
			width: 768,
			height: 480
		},
	],
	alt: 'lorem ipsum test',
	title: 'lorem ipsum',
	width: 1920,
	height: 1080
}

const fakeVideo1: IVideoItem = {
	type: ProductGalleryItemTypes.Video,
	video: {
		overlay: MyMoleculeVideoOverlayLayoutDefault.data,
		consent: MyOrganismVideoDefault.data.consent,
		video: {
			instanceId: uuidv4(),
			videoId: 'tgdbb87PY9k',
			settings: {
				// autoplay: false,
				mute: false,
				controls: false,
				loop: false,
			},
			poster,//: 'https://picsum.photos/id/1001/1024/768',
			thumb: 'https://picsum.photos/id/1001/140/128',
		},
	},
};
export class ProductGalleryVideoItem implements IVideoItem {
	type: ProductGalleryItemTypes.Video;
	video: OrganismVideoProps;
	constructor(data: IVideoItem) {
		if (data) {
			this.type = data.type;
			this.video = data.video;
			// set a unique instance ID
			this.video.video.instanceId = uuidv4();
		}
	}

}
const fakeVideo2: IVideoItem = {
	type: ProductGalleryItemTypes.Video,
	video: {
		overlay: MyMoleculeVideoOverlayLayoutDefault.data,
		consent: MyOrganismVideoDefault.data.consent,
		video: {
			instanceId: uuidv4(),
			videoId: 'RvRhUHTV_8k',
			settings: {
				// autoplay: false,
				mute: false,
				controls: false,
				loop: false,
			},
			poster,
			thumb: 'https://picsum.photos/id/1002/140/128',
		},
	},
};


const fakeMediaItems: MoleculeProductGalleryProps['mediaItems'] = [
	fake360_2,
	fakeImage1,
	fakeImage2,
	fakeImage3,
	fakeVideo1,
	fakeVideo2,
	fake360_2,
	fakeImage4,
	fakeImage5,
];

export const MyMoleculeProductGallery: Component<MoleculeProductGalleryProps> = {
	data: {
		mediaItems: fakeMediaItems,
		energyBadge: MyAtomEnergyBadge.data,
	}
}

export const MyMoleculeProductGalleryManyItems: Component<MoleculeProductGalleryProps> = {
	data: {
		mediaItems: [
			fakeVideo2,
			...fakeMediaItems,
			fakeVideo2,
			...fakeMediaItems,
			fakeVideo2,
			...fakeMediaItems,
		],
		energyBadge: MyAtomEnergyBadge.data,
	}
}

export const MyMoleculeProductGalleryFewItems: Component<MoleculeProductGalleryProps> = {
	data: {
		mediaItems: [
			...fakeMediaItems.slice(0, 2),
		],
		energyBadge: MyAtomEnergyBadge.data,
	}
}

export const MyMoleculeProductGallerySelectedIndex: Component<MoleculeProductGalleryProps> = {
	data: {
		...MyMoleculeProductGallery.data,
		currentlySelected: 1,
	}
}

export const MyMoleculeProductGalleryFullScreen: Component<MoleculeProductGalleryProps> = {
	data: {
		...MyMoleculeProductGallery.data,
		fullscreen: true,
	}
}

interface MediaItem {
	/** Which type the media is */
	type: ProductGalleryItemTypes;
	/** If true, the item will show as the actively selected one. If no active one's, the first is active by default */
	// selected?: boolean;
}
interface IImageItem extends MediaItem {
	type: ProductGalleryItemTypes.Image;
	/** The thumb should be no less than 280px */
	thumb: string;
	large: string;
	full: string;
}
interface IVideoItem extends MediaItem {
	type: ProductGalleryItemTypes.Video;
	// video: VideoData;
	video: OrganismVideoProps;
}

/** @demo https://codesandbox.io/s/6479n17j73?fontsize=14&module=/index.html&file=/index.html:529-1006 */
interface IThreeSixtyItem extends MediaItem {
	type: ProductGalleryItemTypes.ThreeSixty;
	thumb: string;
	/**
	 * The folder where the images are stored
	 * Note: if the images have non-patternized filenames, use this:
	 * @link https://github.com/scaleflex/js-cloudimage-360-view#data-image-list-or-image-list
	 * @link https://github.com/scaleflex/js-cloudimage-360-view#table-of-contents
	 */
	folder: string;
	filenamePattern: string;
	amountOfImages: number;
	magnifierZoom: number;
	spinReverse?: boolean;
	speed?: number;
	autoplay?: boolean;
	keyboard?: boolean;
}
